import { inject, InjectionToken } from '@angular/core';

export enum Platform {
    HWS = 'HWS',
    HCM = 'HCM',
}

export const PLATFORM_TOKEN = new InjectionToken<Platform>('PLATFORM_TOKEN');
export function providePlatformToken(platform: Platform) {
    return {
        provide: PLATFORM_TOKEN,
        useValue: platform,
    };
}

export function isHWS() {
    return inject(PLATFORM_TOKEN) === Platform.HWS;
}

export function isHCM() {
    return inject(PLATFORM_TOKEN) === Platform.HCM;
}
